<template>
  <div class="main">
    <!-- Right -->
    <div class="main_r">
      <!-- search -->
      <div class="search">
        <div>
          <el-button type="primary" @click="clickBack">返回</el-button>
          <el-select v-model="queryData.actionType" placeholder="动作分类">
            <el-option label="动作分类" value="0"></el-option>
            <el-option
              v-for="item in aptustwoGvListActionType" :key="item.gv" :label="item.name" :value="item.gv">
            </el-option>
          </el-select>
          <el-select v-model="queryData.bodyType" placeholder="部位分类">
            <el-option label="部位分类" value=""></el-option>
            <el-option
              v-for="item in aptustwoGvListBodyType" :key="item.gv" :label="item.name" :value="item.gv">
            </el-option>
          </el-select>
          <el-input v-model="queryData.actionName"  placeholder="请输入动作名称"></el-input>
          <el-button type="primary" @click="clickQuery">查询</el-button>
          <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
        </div>
      </div>
      <!-- search End -->

      <!-- 列表 -->
      <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="序号" width="80"></el-table-column>
        <el-table-column prop="actionTypeUi" label="动作分类"></el-table-column>
        <el-table-column prop="bodyTypeUi" label="部位分类"></el-table-column>
        <el-table-column prop="actionName" label="动作名称"></el-table-column>
        <el-table-column prop="" label="动作列表封面" width="120">
          <template v-slot="scope">
            <img :src="scope.row.actionIconUi" min-width="64" height="64" />
          </template>
        </el-table-column>
        <el-table-column prop="actionTime" label="动作时长">
          <template slot-scope="props">
            {{props.row.actionTime}}秒
          </template>
        </el-table-column>
        <el-table-column prop="" label="动作视频" width="120">
          <template v-slot="scope">
            <a :href="scope.row.actionVideoUrlUi" target="_blank">视频</a>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="Operation" label="操作" width="100">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" class="mr12" @click="ClickInsert(scope.row)">添加</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="mt20">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="5"
          layout="prev, pager, next, sizes, jumper "
          :total="dataListnum">
        </el-pagination>
      </div>
      <!-- 分页 End -->
    </div>
    <!-- Right End -->

    <!---------------------- 以下是弹框内容 ---------------------->
    <!-- 添加动作到课程 -->
    <el-dialog title="添加动作到课程" :visible.sync="dialogInsert" width="20%" class="confirmDel">
      <div class="confirmMsg">确定添加这个动作到课程吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="CourseActionInsert" >确 定</el-button>
        <el-button @click="dialogInsert = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 添加动作到课程 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: { },
  data () {
    return {
      formLabelWidth: '120px',
      aptustwoGvListActionType:[],
      aptustwoGvListBodyType:[],
      aptustwoGvListMuscleRoup:[],
      aptustwoGvListAccessories:[],
      queryData: {
        actionType: '0',
        bodyType: '',
        actionName: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      //
      insertForm: {
        sort: '0',
        courseId: '0',
        actionId: '0'
      },
      dialogInsert: false
    }
  },
  mounted () {
  },
  methods: {
    LoadData (courseId) {
      this.insertForm.courseId = courseId
      this.aptustwoGvListActionType = JSON.parse(localStorage.getItem('aptustwoGvListActionType'));
      this.aptustwoGvListBodyType = JSON.parse(localStorage.getItem('aptustwoGvListBodyType'));
      this.aptustwoGvListMuscleRoup = JSON.parse(localStorage.getItem('aptustwoGvListMuscleRoup'));
      this.aptustwoGvListAccessories = JSON.parse(localStorage.getItem('aptustwoGvListAccessories'));
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    clickQuery () {
      this.page_no = 1
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clickQueryReset () {
      this.queryData.actionType = '0'
      this.queryData.bodyType = ''
      this.queryData.actionName = ''
      this.clickQuery()
    },
    ClickInsert (row) {
      this.dialogInsert = true
      this.insertForm.actionId = row.id
    },
    ActionDatabaseList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.actionType = that.queryData.actionType
      data.bodyType = that.queryData.bodyType
      data.actionName = that.queryData.actionName
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_ActionDatabaseList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    ActionDatabaseNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.actionType = that.queryData.actionType
      data.bodyType = that.queryData.bodyType
      data.actionName = that.queryData.actionName
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_ActionDatabaseNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    CourseActionInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sort = that.insertForm.sort
      data.courseId = that.insertForm.courseId
      data.actionId = that.insertForm.actionId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindAllways(response.data)
          if (response.data.code === 1) {
            Vue.prototype.$alert('添加成功', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                that.dialogInsert = false
              }
            });
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 150px;
    margin-right: 15px;
  }

  .el-select{
    width: 150px;
    margin-right: 15px;
  }

  .el-button{
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
